import { axios } from '@/utils/request'

const api = {
  login: '/sso/user/login',
  logout: '/sso/user/logout',
  getUserInfoByHideCode: '/sso/user/getUserInfoByHideCode', // 查询主体subjectid
  chooseLanguage: '/sso/user/chooseLanguage',
  transformLoginByOther: '/sso/user/transformLoginByOther',
  register: '/sso/user/register', // 普通注册
  firstBindingPhoneEmailPsw: '/sso/user/firstBindingPhoneEmailPsw', // 钉钉扫码注册
  checkShowHelpInfo: '/sso/user/checkShowHelpInfo', // 查询是否需要显示引导
  retrievePassByPhone: 'sso/user/retrievePassByPhone', // 手机号找回密码
  retrievePassByEmail: '/sso/user/retrievePassByEmail', // 邮箱找回密
  sendRetrievePassEmail: '/sso/user/sendRetrievePassEmail', // 邮箱验证码·找回密码页面
  sendRetrievePassCore: '/sso/user/sendRetrievePassCore', // 手机号验证码·找回密码页面
  getPackageStyle: '/sso/user/getPackageStyle', // 查询套餐样式
  changePackageStyle: '/sso/user/changePackageStyle', // 修改套餐样式
  selMuchTransformLogin: '/sso/user/selMuchTransformLogin' // 亿数通token解析转换
}
export default api
export const login = async params => axios.post(api.login, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const logout = params => axios.post(api.logout, params)
export const getUserInfoByHideCode = params => axios.post(api.getUserInfoByHideCode, params)
export const chooseLanguage = params => axios.post(api.chooseLanguage, params)
export const transformLoginByOther = params => axios.post.post(api.transformLoginByOther, params)
export const register = async params => axios.post(api.register, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const firstBindingPhoneEmailPsw = async params => axios.post(api.firstBindingPhoneEmailPsw, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const checkShowHelpInfo = async params => axios.post(api.checkShowHelpInfo, params)
export const retrievePassByPhone = async params => axios.post(api.retrievePassByPhone, params)
export const retrievePassByEmail = async params => axios.post(api.retrievePassByEmail, params)
export const sendRetrievePassEmail = async params => axios.post(api.sendRetrievePassEmail, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const sendRetrievePassCore = async params => axios.post(api.sendRetrievePassCore, Object.assign({ systemCode: 'SSO_SYS_USER' }, params))
export const getPackageStyle = async params => axios.post(api.getPackageStyle, params)
export const changePackageStyle = async params => axios.post(api.changePackageStyle, params)
export const selMuchTransformLogin = async params => axios.post(api.selMuchTransformLogin, params)
